import React from "react";
import { Row } from 'react-bootstrap';
import { ActividadSimplebar } from '../../ActividadSimplebar/ActividadSimplebar';
import { ErrorBoundary } from '../../ErrorBoundary';
import LeftSectionHeader from '../LeftSection/LeftSectionHeader/LeftSectionHeader';
import LeftSectionBody from '../LeftSection/LeftSectionBody/LeftSectionBody';
import RightSection from '../RightSection/RightSection';
import LeftSection from '../LeftSection/LeftSection';
import { ActividadesProvider } from '../../../Providers';
import Skeleton from 'react-loading-skeleton';
import "react-loading-skeleton/dist/skeleton.css";
import { useTheme } from "../../../Hooks";
import './PantallaView.css';

function PantallaView(props) {
    const { theme } = useTheme();
    const hideLeftSection = props.ViewConfig && props.ViewConfig.hideLeftSection;

    return (
        <div
            className='bootstrapiso'
            id="pantallaView"
            style={{ margin: "0", overflowY: "hidden", overflowX: "hidden" }}
        >
            {props.StatesFlow && props.StatesFlow.show && (
                <div className="bg-white border-bottom">
                    {props.StatesFlow.isDoneLoading && !props.StatesFlow.isCotization ? (
                        <ErrorBoundary>
                        </ErrorBoundary>
                    ) : props.StatesFlow.isDoneLoading &&
                    props.StatesFlow.isCotization ? (
                        <ErrorBoundary>
                        </ErrorBoundary>
                    ) : (
                        <div className="p-1 border-bottom">
                            <Skeleton
                                height={"45px"}
                                borderRadius={"1rem"}
                                baseColor={theme.skeletonColor}
                            />
                        </div>
                    )}
                </div>
            )}
            <Row style={{ margin: "0", overflowY: "hidden" }}>
                <ActividadesProvider>
                    <ActividadSimplebar {...props.CreationCanvas} />
                    {!hideLeftSection && (
                        <div
                            style={{
                                width: "25%",
                                minHeight:
                                    props.ViewConfig && props.ViewConfig.simplebar
                                        ? `85vh`
                                        : `calc(100vh - ${theme.MAX_HEIGHT_HEADER})`,
                                padding: 0
                            }}
                        >
                            <ErrorBoundary>
                                <LeftSection
                                    simplebar={props.ViewConfig && props.ViewConfig.simplebar}
                                    height={props.LeftSectionBody.HEIGHT}
                                >
                                    <LeftSectionHeader {...props.LeftSectionHeader} />
                                    <LeftSectionBody {...props.LeftSectionBody} />
                                </LeftSection>
                            </ErrorBoundary>
                        </div>
                    )}
                    <div
                        style={{
                            width: hideLeftSection ? "100%" : "75%",
                            minHeight:
                                props.ViewConfig && props.ViewConfig.simplebar
                                    ? `85vh`
                                    : `calc(100vh - 200px)`,
                            padding: 0
                        }}
                    >
                        <ErrorBoundary>
                            <RightSection
                                simplebar={props.ViewConfig && props.ViewConfig.simplebar}
                                {...props.RightSection}
                            ></RightSection>
                        </ErrorBoundary>
                    </div>
                </ActividadesProvider>
            </Row>
        </div>
    );
}
export default PantallaView;
